export default __webpack_public_path__ + "static/media/4934.e9e22176.png";